import dayjs from 'dayjs'
import { IoEyeOutline } from 'react-icons/io5'

import { labels } from '@/constants/labels'
import { Record } from '@/models/record'
import { ButtonApp } from '@/components'

type ColumnProps = { data: Record }

export const columnsRecords = (selectRecord: (record: Record) => void) => {
  return [
    { field: 'currentValue', headerName: labels.currentValue },
    { field: 'newValue', headerName: labels.newValue },
    {
      field: 'updated',
      headerName: labels.date,
      cellRenderer: (props: ColumnProps) => (
        <p>{props.data.updated ? dayjs(props.data.updated).format('MM-DD-YYYY') : ''}</p>
      ),
    },
    {
      headerName: 'Compare changes',
      cellRenderer: ({ data: record }: ColumnProps) => (
        <div className="h-full flex items-center">
          <ButtonApp
            className="px-4 py-1.5 gap-2 h-8"
            handleClick={(e) => {
              e.stopPropagation()
              selectRecord(record)
            }}
          >
            <IoEyeOutline className="text-xl text-gray-400" />
            <span className="text-sm">Preview</span>
          </ButtonApp>
        </div>
      ),
    },
  ]
}
